module.exports = __webpack_public_path__ + "img/icon_sale_gray.1c8f64a6.svg";